/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Docs_Key_PointsInputs */

const en_public_docs_key_points = /** @type {(inputs: Public_Docs_Key_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Points`)
};

const es_public_docs_key_points = /** @type {(inputs: Public_Docs_Key_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntos clave`)
};

/**
* | output |
* | --- |
* | "Key Points" |
*
* @param {Public_Docs_Key_PointsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const public_docs_key_points = /** @type {((inputs?: Public_Docs_Key_PointsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Docs_Key_PointsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_public_docs_key_points(inputs)
	return en_public_docs_key_points(inputs)
});